import * as React from "react";
import { CpbxApiHelper } from "../../../helpers/CpbxApiHelper";
import { LocalCacheHelper } from "../../../helpers/LocalCacheHelper";

export default class ProxyHealthCheck extends React.Component {

    private lcCpbxBa;
    private lcCpbxUserIv;
    private lcM365UserObjectId;
    private reqHeaders;

    /* eslint-disable */
    constructor(props) {
        super(props);
    }
    /* eslint-enable */

    state = {
        data: {},
        isSignIn: false
        // key: null,
        // value:null,
        // items:[]
    }

    componentDidMount() {
        // console.log("start componentDidMount CpbxDirectory");
        this.lcCpbxBa = LocalCacheHelper.GetLocalStorageItemCbpxUserBasicAuthStringAsString();
        this.lcCpbxUserIv = LocalCacheHelper.GetLocalStorageItemCbpxUserIVString();
        this.lcM365UserObjectId = LocalCacheHelper.GetLocalStorageItemM365UserObjectId();
        this.reqHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithAuthPsa(this.lcCpbxBa, this.lcM365UserObjectId, this.lcCpbxUserIv);
        if (LocalCacheHelper.DoesLocalCacheKeysForCbpxLoginExists()) {
            this.loadHealthTabelleFromServer();
            this.setState({
                isSignIn: true
            });
        }
    }

    loadHealthTabelleFromServer() {
        fetch(LocalCacheHelper.GetLocalStorageItemCbpxProxyUrl() + "/psa/ProxyHealthStatus", {
            method: "GET",
            headers: this.reqHeaders,
            redirect: "follow"
        }).then((response) => {
            console.log("response.ok='" + response.ok + "'");
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Response not ok");
            }
        }).then((data) => {
            console.log("data", data);
            const copyData = data;
            this.setState(
                {
                    data: copyData
                    // key: Object.keys(data.health_data),
                    // value:  Object.values(data.health_data),
                    // items: Object.entries(data.health_data)
                }
            );
        }).catch((error) => {
            console.log("Es ist ein unerwarteter Fehler aufgetreten: ", error);
        });
    }

    objectReduceConcat(data:any) {
        const concat = {};
        for (const key in data) {
            if (typeof (data[key]) === "object") {
                for (const i in data[key]) {
                    // console.log(`key ${i} value ${data[key][i]}`);
                    concat[i] = data[key][i];
                }
            } else {
                // console.log(`key ${key} value ${data[key]}`);
                concat[key] = data[key];
            }
        }
        console.log("Neues Object", concat);
        return concat;
    }

    render() {

        const table = Object.entries(this.objectReduceConcat(this.state.data)).map((key:any) => {
            return (
                /* eslint-disable */
                <tr>
                    <td>{key[0]}</td>
                    <td><span style = {key[1] === true ? { color: "green" } : key[1] === false ? { color: "red" } : { color: "black" }}>{key[1].toString()}</span></td>
                </tr>
                /* eslint-enable */
            );
        });

        return (
            <> { this.state.isSignIn
                ? <table>
                    <thead>
                        <tr>
                            <th>KEY</th>
                            <th>VALUE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {table}
                    </tbody>
                </table>
                : <h1>Bitte loggen Sie sich ein</h1>
            }
            </>
        );
    }

}
